import type { Interpolation, Theme } from "@emotion/react";
import type { FC } from "react";

import { SupportTicketInvoiceOrderFields } from "./SupportTicketInvoiceOrderFields";

type Props = {
  invoiceNumber: string;
  orderNumber: string;
  onInvoiceNumberChange: (value: string) => void;
  onOrderNumberChange: (value: string) => void;
  onInvoiceBlur?: () => void;
  onOrderBlur?: () => void;
  isDisabled?: boolean;
  fieldClassName?: Interpolation<Theme>;
};

export const SupportTicketInvoiceNumberField: FC<Props> = (props) => {
  return <SupportTicketInvoiceOrderFields {...props} />;
};
